import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=6d9a1007&scoped=true&"
import script from "./GoodsCard.vue?vue&type=script&lang=js&"
export * from "./GoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=6d9a1007&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a1007",
  null
  
)

export default component.exports